import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import esLocale from 'i18n-iso-countries/langs/es.json';
import { isEnglishLocale } from './locale';

countries.registerLocale(enLocale);
countries.registerLocale(esLocale);

const getCountryLocale = (locale) => (isEnglishLocale(locale) ? 'en' : 'es');

export const getLocalizedCountryOptions = (locale) => {
  const language = getCountryLocale(locale);
  const names = countries.getNames(language, { select: 'official' });

  return Object.entries(names)
    .map(([, name]) => String(name || '').trim())
    .filter(Boolean)
    .map((name) => ({ label: name, value: name }))
    .sort((left, right) => left.label.localeCompare(right.label, language));
};